import { useEffect } from 'react'

import { useTranslation } from 'react-i18n-lite'

import { useSelector } from 'react-redux'

import { useParams } from 'react-router-dom'

import { AuthenticationType } from 'authentication/shared/types'

import useIframe from 'interaction/Embed/hooks/useIframe'

import Iframe from 'shared/components/Iframe'

import useObjectClassById from './hooks/useObjectClassById'

type Params = {
  readonly objectUuid: string | undefined
}

const Container: React.FunctionComponent = (): JSX.Element | null => {
  const { language } = useTranslation()

  const { objectUuid } = useParams<Params>()

  const uuid_Objectclass = useObjectClassById(objectUuid)

  const urlMasterdata = window.waMasterdataUrl

  const token = useSelector(
    ({ authentication }: AuthenticationType) => authentication.token
  )

  const queryString = `token=${token}&lang=${language}`

  const iframeSrc = `${urlMasterdata}register/${uuid_Objectclass}/${objectUuid}?${queryString}`

  const { iframeAttributes, receiveMessage } = useIframe({
    origin: urlMasterdata,
    src: iframeSrc,
    title: 'Masterdata',
    name: 'masterdata'
  })

  useEffect(() => {
    window.addEventListener('message', receiveMessage)
    return () => window.removeEventListener('message', receiveMessage)
  })

  return iframeAttributes ? <Iframe {...iframeAttributes} /> : null
}

export default Container
